export default "__VITE_ASSET__CaaCj0rz__";